import React, { memo, useContext } from 'react';

import { AppContext } from 'App';

import './Features.scss';

const Features = () => {
  const { pageData } = useContext(AppContext);
  const { title, list } = pageData?.features;

  return (
    <section id="featuresSection" className="features_section">
      <div className="container">
        <h2 className="features_head">{title}</h2>
        <div className="features_list">
          <div className="row">
            {list?.map((item, index) => {
              return (
                <div className="flg-lg-6 flg-md-6 flg-sm-12 box_list" key={index}>
                  <div className="box_content">
                    <img src={item.image} alt="" />
                    <h2 className="box_head">{item.title}</h2>
                    <p className="box_sub_text">{item.subTitle}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default memo(Features);
